let serviceRequestsInitialized = false;

const SPACING = 8;
const OFFSET = 6;
let activeDropdownState = null;

const setImportantStyle = (element, property, value) => {
  if (!element) {
    return;
  }

  element.style.setProperty(property, value, "important");
};

const getDropdownState = (container) => {
  if (!container) {
    return null;
  }

  const toggle = container.querySelector('[data-bs-toggle="dropdown"]');
  const menu = container.__portalMenu || container.querySelector(".service-requests-actions-menu");
  if (!toggle || !menu) {
    return null;
  }

  return {
    container,
    toggle,
    menu,
  };
};

const resetDropdownMenuStyles = (menu) => {
  if (!menu) {
    return;
  }

  setImportantStyle(menu, "left", "0px");
  setImportantStyle(menu, "top", "0px");
  setImportantStyle(menu, "right", "auto");
  setImportantStyle(menu, "bottom", "auto");
  setImportantStyle(menu, "transform", "none");
  menu.style.removeProperty("min-width");
};

const disableBootstrapDropdownPopper = (toggle, menu) => {
  if (!toggle || !window.bootstrap || !window.bootstrap.Dropdown) {
    return;
  }

  const dropdown = window.bootstrap.Dropdown.getInstance(toggle);
  if (dropdown && dropdown._popper) {
    dropdown._popper.destroy();
    dropdown._popper = null;
  }

  if (menu) {
    menu.removeAttribute("data-bs-popper");
  }
};

const positionDropdownMenu = (state) => {
  if (!state) {
    return;
  }

  const { toggle, menu } = state;
  resetDropdownMenuStyles(menu);

  const toggleRect = toggle.getBoundingClientRect();
  const menuRect = menu.getBoundingClientRect();
  const menuWidth = Math.ceil(menuRect.width || menu.offsetWidth || 0);
  const menuHeight = Math.ceil(menuRect.height || menu.offsetHeight || 0);
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

  let left = Math.round(toggleRect.right - menuWidth);
  if (left < SPACING) {
    left = SPACING;
  }
  if (left + menuWidth > viewportWidth - SPACING) {
    left = Math.max(SPACING, viewportWidth - menuWidth - SPACING);
  }

  let top = Math.round(toggleRect.bottom + OFFSET);
  if (top + menuHeight > viewportHeight - SPACING && toggleRect.top - menuHeight - OFFSET >= SPACING) {
    top = Math.round(toggleRect.top - menuHeight - OFFSET);
  }
  if (top < SPACING) {
    top = SPACING;
  }

  setImportantStyle(menu, "left", left + "px");
  setImportantStyle(menu, "top", top + "px");
  setImportantStyle(menu, "right", "auto");
  setImportantStyle(menu, "bottom", "auto");
  setImportantStyle(menu, "transform", "none");
  setImportantStyle(menu, "min-width", Math.round(Math.max(toggleRect.width, menuWidth)) + "px");
  setImportantStyle(menu, "z-index", "1085");
  setImportantStyle(menu, "visibility", "visible");
};

const portalizeDropdown = (container) => {
  const state = getDropdownState(container);
  if (!state) {
    return;
  }

  const { toggle, menu } = state;
  if (menu.dataset.portalized !== "1") {
    const placeholder = document.createComment("service-requests-actions-menu-placeholder");
    menu.parentNode.insertBefore(placeholder, menu.nextSibling);
    menu.__portalPlaceholder = placeholder;
    container.__portalMenu = menu;
    document.body.appendChild(menu);
    menu.dataset.portalized = "1";

    setImportantStyle(menu, "position", "fixed");
    setImportantStyle(menu, "inset", "auto auto auto auto");
    setImportantStyle(menu, "margin", "0");
    setImportantStyle(menu, "max-width", "calc(100vw - 16px)");
    setImportantStyle(menu, "visibility", "hidden");
  }

  activeDropdownState = getDropdownState(container);
  disableBootstrapDropdownPopper(toggle, menu);

  window.requestAnimationFrame(() => {
    positionDropdownMenu(activeDropdownState);
    window.requestAnimationFrame(() => {
      positionDropdownMenu(activeDropdownState);
    });
  });
};

const restoreDropdown = (container) => {
  if (!container || !container.__portalMenu) {
    return;
  }

  const menu = container.__portalMenu;
  const placeholder = menu.__portalPlaceholder;

  if (placeholder && placeholder.parentNode) {
    placeholder.parentNode.insertBefore(menu, placeholder);
    placeholder.parentNode.removeChild(placeholder);
  } else {
    container.appendChild(menu);
  }

  menu.style.removeProperty("position");
  menu.style.removeProperty("inset");
  menu.style.removeProperty("margin");
  menu.style.removeProperty("max-width");
  menu.style.removeProperty("left");
  menu.style.removeProperty("top");
  menu.style.removeProperty("right");
  menu.style.removeProperty("bottom");
  menu.style.removeProperty("transform");
  menu.style.removeProperty("min-width");
  menu.style.removeProperty("z-index");
  menu.style.removeProperty("visibility");
  menu.removeAttribute("data-portalized");

  delete menu.__portalPlaceholder;
  delete container.__portalMenu;

  if (activeDropdownState && activeDropdownState.container === container) {
    activeDropdownState = null;
  }
};

const bindDropdownEvents = () => {
  document.addEventListener("shown.bs.dropdown", (event) => {
    const container = event.target.closest(".service-requests-actions-dropdown");
    if (!container) {
      return;
    }

    portalizeDropdown(container);
  });

  document.addEventListener("hide.bs.dropdown", (event) => {
    const container = event.target.closest(".service-requests-actions-dropdown");
    if (!container) {
      return;
    }

    restoreDropdown(container);
  });

  document.addEventListener(
    "scroll",
    () => {
      if (!activeDropdownState) {
        return;
      }

      positionDropdownMenu(activeDropdownState);
    },
    true
  );

  window.addEventListener("resize", () => {
    if (!activeDropdownState) {
      return;
    }

    positionDropdownMenu(activeDropdownState);
  });
};

const prepareDropdowns = () => {
  document.querySelectorAll('.service-requests-actions-dropdown [data-bs-toggle="dropdown"]').forEach((toggle) => {
    if (!toggle.dataset.bsDisplay) {
      toggle.dataset.bsDisplay = "static";
    }
  });
};

export const initServiceRequestsPage = () => {
  if (serviceRequestsInitialized) {
    return;
  }

  if (!document.querySelector(".service-requests-actions-dropdown")) {
    return;
  }

  serviceRequestsInitialized = true;
  prepareDropdowns();
  bindDropdownEvents();
};

